import { Container, ContainerGutter, CTA, Spinner, ThemeProvider } from '@volkswagen-onehub/components-core';
import React from 'react';
import { PdfHuchaContent } from '../../../shared/components/pdf-hucha-content';
import { useHuchaPdfGenerator } from '../../../shared/hooks/use-hucha-pdf-generator';
import { useHuchaPopup } from '../../../shared/hooks/use-hucha-popup';
import { HuchaVentaValues } from '../../../shared/models/hucha-values';
import { useHuchaVentaLayerContent } from '../../hooks/use-hucha-venta-layer-content';

export const HuchaStandardButtons = ({
	huchaValues,
	dataTestId,
}: {
	huchaValues: HuchaVentaValues;
	dataTestId?: string;
}) => {
	const targetRefPDF = React.useRef<HTMLDivElement>(null);
	const { handlePdfDownloadClick, isDownloading, isPdfReady } = useHuchaPdfGenerator(huchaValues, targetRefPDF);
	const { huchaVentaPdfLayerContent, huchaVentaPopupLayerContent } = useHuchaVentaLayerContent(huchaValues);
	const { handlePopupOpen } = useHuchaPopup({ huchaValues, layerContent: () => huchaVentaPopupLayerContent });

	return (
		<>
			<ThemeProvider theme="inverted">
				<Container
					data-testid={dataTestId}
					wrap="always"
					stretchContent
					verticalAlign="center"
					horizontalAlign="center"
					gutter={ContainerGutter.static300}
				>
					<CTA
						tag="button"
						emphasis="secondary"
						onClick={handlePdfDownloadClick}
						// icon={isDownloading ? <Spinner /> : <Download variant="small" />}
						icon={isDownloading ? <Spinner /> : undefined}
					>
						{isDownloading ? 'Descargando' : 'Descargar ahorro acumulado'}
					</CTA>
					<CTA
						tag="button"
						emphasis="primary"
						onClick={handlePopupOpen}
						// icon={<LinkExternal variant="small" />}
					>
						Más sobre tus ahorros
					</CTA>
				</Container>
			</ThemeProvider>
			{isPdfReady && <PdfHuchaContent targetRef={targetRefPDF} layerContent={() => huchaVentaPdfLayerContent} />}
		</>
	);
};
